import axios from "axios";

const scrollToTop = () => {
  try {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  } catch (error) {
    window.scrollTo(0, 0);
  }
};

const updateLocalStorageToken = (token) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  userInfo.token = token
  const updatedUserInfo = JSON.stringify(userInfo);
  localStorage.setItem('userInfo', updatedUserInfo);
  axios.defaults.headers.common['Authorization'] = `Bearer ${userInfo.token}`;
}

const logOut = () => {
  localStorage.clear();
  window.location.href = '/login';
}

const fortmatDate = (date) => {
  if (date) {
    var d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  return '';
};

const formatMonthYear = (dateValue) => {
  if (!dateValue) return '';

  const value = String(dateValue);
  const datePart = value.split(' ')[0]?.split('T')[0];
  if (!datePart) return '';

  const [year, month, day] = datePart.split('-').map(Number);
  if (!year || !month || !day) return '';

  const d = new Date(year, month - 1, day);
  const dayStr = String(d.getDate()).padStart(2, '0');
  const monthNames = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const monthStr = monthNames[d.getMonth()];
  const yearStr = d.getFullYear();

  return `${dayStr} de ${monthStr} del ${yearStr}`;
}

const setSHourStartDateToNoon = (dateStr) => {
  const date = new Date(dateStr.replace(" ", "T"));
  date.setHours(10, 0, 0, 0);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

const setSHourEndDateToNoon = (dateStr) => {
  const date = new Date(dateStr.replace(" ", "T"));
  date.setHours(15, 0, 0, 0);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}


export {
  scrollToTop,
  updateLocalStorageToken,
  fortmatDate,
  formatMonthYear,
  setSHourStartDateToNoon,
  setSHourEndDateToNoon,
  logOut,
};